/**
 * @file router.js
 */

import Vue from 'vue';
import Router from 'vue-router';

const Home = () => import(/* webpackChunkName: "home" */ '@/views/Home/Home.vue');
const EditTopic = () => import(/* webpackChunkName: "editTopic" */ '@/views/EditTopic/EditTopic.vue');
const TopicContent = () => import(/* webpackChunkName: "topicContent" */ '@/views/TopicContent/TopicContent.vue');

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: '/community/',
    routes: [
        {
            path: '/topic/list/0',
            name: 'home',
            component: Home,
            alias: '/'
        },
        {
            path: '/topic/list',
            name: 'homeTab',
            component: Home
        },
        {
            // 发帖页
            path: '/topic/add',
            name: 'addTopic',
            component: EditTopic
        },
        {
            // 编辑帖子页面
            path: '/topic/edit/:topicid',
            name: 'editTopic',
            component: EditTopic
        },
        {
            // 帖子详情页
            path: '/topic/show/:topicid',
            name: 'topicContent',
            component: TopicContent
        },
        {
            path: '*',
            redirect: {
                path: '/'
            }
        }
    ]
});

const formatParams = (to, next) => {
    if (Object.keys(to.params).length) {
        let params = to.params;
        let key = Object.keys(params)[0];
        let id = params[key];
        let Id = id;
        if (key !== 'userNo') {
            Id = parseInt(id, 10);
        }
        if (Id === id || Id + '' === id) {
            next();
        }
        else if (isNaN(Id)) {
            next({path: '/', replace: true});
        }
        else {
            let name = to.name;
            params[key] = Id;
            next({name, params, replace: true});
        }
    }
    else {
        next();
    }
};
router.beforeEach((to, from, next) => {
    // 页面设置title
    if (to.meta && to.meta.title) {
        document.title = to.meta.title;
    }
    // 校验参数合法性
    formatParams(to, next);
});

export default router;
